import { Injectable } from '@angular/core';
import { BrandTypesEnum } from '../enums/brand-types-enum';
import { CrmTypesEnum } from '../enums/crm-types-enum';
import { ShopTypesEnum } from '../enums/shop-types-enum';
import { UsaStatesEnum } from 'src/shop-manager/common/enums/usa-states-enum';
import { SubscriptionDurationType } from 'src/patient-manager/common/enums/subscription-duration-type';
import { CountriesEnum } from '../enums/countries-enum';
import { BRANDS_BY_COUNTRY, COUNTRY_TO_ID, CountryId } from '../constants/country-configs.constants';

@Injectable({
  providedIn: 'root'
})
export class ServerValueInterpreterService
{

  constructor() { }

  getStateName(state:string): string {
    // Ensure the state is a valid key of the enum
    let stateKey: keyof typeof UsaStatesEnum = state as keyof typeof UsaStatesEnum;
    return UsaStatesEnum[stateKey] || 'Unknown State'; // Fallback to 'Unknown State' if key is invalid
  }

  getFullCountryNameById(countryId: CountryId): CountriesEnum
  {
      return CountriesEnum[countryId]
  }

  getBrandIdByCountryId(countryId: CountryId): BrandTypesEnum
  {
    return BRANDS_BY_COUNTRY[countryId];
  }

  getCRMNameByNumber(crmNumber: number): CrmTypesEnum | undefined
  {
    switch (crmNumber)
    {
      case 4: return CrmTypesEnum.CONNECTHEARING
      case 5: return CrmTypesEnum.ELITE
      case 6: return CrmTypesEnum.ALPACA
      default: return undefined
    }
  }

  getIdByFullCountryName(countryFullname: CountriesEnum): CountryId
  {
      return COUNTRY_TO_ID[countryFullname];
  }

  getFullType1(type1: ShopTypesEnum): string
  {
    switch (type1)
    {
      case ShopTypesEnum.clinic: return 'Clinic'
      case ShopTypesEnum.entOffice: return 'ENT Office'
      default:
        return type1
    }
  }

  getBrandName(brandID: BrandTypesEnum): string
  {
    switch (brandID)
    {
      case BrandTypesEnum.SILENTCLOUD: return "SilentCloud";
      case BrandTypesEnum.AUDIONOVA: return "AudioNova";
      case BrandTypesEnum.SCHOONENBERG: return "Schoonenberg";
      case BrandTypesEnum.LAPPERRE: return "Lapperre";
      case BrandTypesEnum.CONNECTHEARING: return "Connect Hearing";
      case BrandTypesEnum.BOOTSHEARINGCARE: return "Boots Hearingcare";
      case BrandTypesEnum.AUDIONOVAUS: return "AudioNova";
      case BrandTypesEnum.PHONAKGS: return "Phonak Government Services";
      default:
        return brandID
    }
  }

  getSubscriptionDurationText(type: SubscriptionDurationType)
    {
      switch (type) {
        case SubscriptionDurationType.freeTrial: return "Free trial"
        case SubscriptionDurationType.oneMonth: return "One month"
        case SubscriptionDurationType.sixMonths: return "Six months"
        case SubscriptionDurationType.testing: return "Testing"
        default: return "None"
          break;
      }
    }
}
